import { IPromoInfo } from '../../../types/newbuildingPromos';
import { calculateMonthlyPayment } from '../../../utils/motgageCalculator';

interface IMonthlyPaymentConditions {
  initialPayment: number;
  loanTerm: number;
  price: number;
}

export const getMonthlyPayment = (promo: IPromoInfo, conditions: IMonthlyPaymentConditions): number | undefined => {
  const interestRate = promo.mortgageParams?.interestRate;

  if (!interestRate && interestRate !== 0) {
    return undefined;
  }

  return calculateMonthlyPayment({ ...conditions, interestRate });
};
